import { render, staticRenderFns } from "./EvaluacionPage.vue?vue&type=template&id=686b046b"
import script from "./EvaluacionPage.js?vue&type=script&lang=js&external"
export * from "./EvaluacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports